export default __webpack_public_path__ + "static/media/Fallen Leviathan's Mantle of the Living Legend.796f7d31.jpg";